export default __webpack_public_path__ + "static/media/Saly-16.11a61f48.svg";